<template>
  <div>
    <vue-headful
      title="Class Report | School Dashboard"
      description="Description goes here"
    />
    <div class="class-report-section sub-type-layout">
      <div class="container px-1">
        <div class="row">
          <!-- CLASS BRANCH INFO COLUMN -->
          <div class="col-12 col-md-3 col-lg-3 left-layout">
            <!-- MEMBERS CARD COMPONENT -->
            <MembersCard @updateTeacher="num_counter++">
              <!-- LOADER -->
              <div
                class="loader d-flex justify-content-center align-items-center my-4"
                v-if="teacher_count === null"
              >
                <div class="avatar">
                  <span
                    class="icon-dotted-spinner flex-center font-22 border_grey_dark animate mr-2"
                  ></span>
                </div>
                <div class="border_grey_dark font-13">Loading Teachers ...</div>
              </div>
              <!-- LOADER -->

              <div slot="teacher__content" v-else>
                <!-- CONTENT TEACHER LIST -->
                <MembersTeacherRow
                  v-if="teacher_count > 0"
                  :teachers_list="teacher_data"
                  @toggleTeacher="toggleTeacherModal"
                ></MembersTeacherRow>

                <!-- EMPTY TEACHER LIST -->
                <div class="teacher-list-empty mb-3">
                  <MembersEmptyTeacherRow
                    v-if="teacher_count === 0"
                    @toggleTeacher="toggleTeacherModal"
                  ></MembersEmptyTeacherRow>
                </div>
              </div>
            </MembersCard>
            <!-- MEMBERS CARD COMPONENT -->
          </div>
          <!-- CLASS BRANCH INFO COLUMN -->

          <!-- CLASS REPORT -->
          <div class="col-12 col-md-9 col-lg-9 right-layout">
            <!-- PAGE TITLE -->
            <div class="page-title font-weight-bold color_text">
              Class Report
            </div>

            <!-- REPORT ROW -->
            <div
              class="report-intro-row d-flex justify-content-between align-items-center nowrap"
            >
              <!-- SUBJECT AND TERM -->
              <div
                class="left d-flex justify-content-start align-items-center nowrap"
              >
                <!-- SUBJECT SELECT -->
                <div class="subject">
                  <select
                    class="form-control"
                    @change="updateParam($event.target.value, 'subject')"
                  >
                    <template v-if="subject_list.length">
                      <option
                        :value="subject.slug"
                        :selected="current_subject.slug === subject.slug"
                        v-for="(subject, index) in subject_list"
                        :key="index"
                      >
                        {{ subject.name }}
                      </option>
                    </template>
                    <template v-else>
                      <option value>Select subject</option>
                    </template>
                  </select>
                </div>

                <!-- TERM SELECT -->
                <div class="term">
                  <select
                    class="form-control"
                    @change="updateParam($event.target.value, 'term')"
                  >
                    <template>
                      <option value="first" :selected="current_term == 'first'">
                        first
                      </option>
                      <option
                        value="second"
                        :selected="current_term == 'second'"
                      >
                        second
                      </option>
                      <option value="third" :selected="current_term == 'third'">
                        third
                      </option>
                    </template>
                  </select>
                </div>
              </div>

              <!-- EXPORT -->
              <div class="right d-none d-md-block" v-if="false">
                <div class="export-btn rounded-30 color_grey_dark pointer">
                  <div>Export</div>
                  <div class="avatar">
                    <span class="flex-center icon-printer color_ash"></span>
                  </div>
                </div>
              </div>
            </div>

            <!-- RECOMMENDATION COMPONENTONENT -->
            <Recommendation
              :report="report_data"
              :loaded_view="loaded_view"
              @update-topic="updateParam($event.value, $event.type)"
            ></Recommendation>
            <!-- RECOMMENDATION COMPONENTONENT -->

            <!-- TOPIC PROGRESS COMPONENT -->
            <TopicProgress
              :report="report_data"
              v-if="total_report_count"
              @update-topic="updateParam($event.value, $event.type)"
            ></TopicProgress>
            <!-- TOPIC PROGRESS COMPONENT -->
          </div>
          <!-- CLASS REPORT -->
        </div>
      </div>
    </div>
    <!-- ADD TEACHER MODAL -->
    <AddTeacherModal
      v-if="teacher_modal"
      @closeTriggered="toggleTeacherModal"
    ></AddTeacherModal>

    <SectionLoader :loader_text="loader_text" v-if="show_loader" />
    <!-- ADD TEACHER MODAL -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MembersCard from "@/components/classComps/studentSideBar/MembersCard";
import TeachersInClass from "@/scripts/mixins/TeachersInClass";
import MembersEmptyTeacherRow from "@/components/classComps/studentSideBar/MembersEmptyTeacherRow";
import TopicProgress from "@/components/classComps/report/TopicProgress";
import { EventBus } from "@/scripts/event-bus.js";
import SectionLoader from "@/components/globalComps/SectionLoader";

const MembersTeacherRow = () => ({
  /* webpackChunkName: "MembersTeacherRow" */
  component: import("@/components/classComps/studentSideBar/MembersTeacherRow"),
  loading: MembersEmptyTeacherRow,
  error: MembersEmptyTeacherRow,
  delay: 100,
  timeout: 20000,
});

export default {
  name: "ClassReport",

  mixins: [TeachersInClass],

  components: {
    MembersCard,
    MembersEmptyTeacherRow,
    MembersTeacherRow,
    TopicProgress,
    SectionLoader,
    Recommendation: () =>
      import(
        /* webpackChunkName: "Recommendation" */
        "@/components/classComps/report/Recommendation"
      ),
    AddTeacherModal: () =>
      import(
        /* webpackChunkName: "AddTeacherModal" */
        "@/components/modalComps/schoolModals/AddTeacherModal"
      ),
  },

  computed: {
    ...mapGetters(["getCurrentClass"]),
  },

  watch: {
    $route: {
      handler(newVal) {
        if (newVal) {
          this.clearOutOptionalPrams();
          this.getReport();
        }
      },
      immediate: true, // make this watch function is called when component created
    },
  },

  data() {
    return {
      teacher_modal: false,

      current_subject: "",
      current_term: "",
      subject_list: [],

      topic_id: null,
      subject: null,
      term: null,

      total_report_count: 0,

      report_data: {
        current_subject: {},
        current_topic: {},
        topic_list: [],
        struggling_student: [],
        average_student: [],
        excellence_student: [],
        total_student_count: 0,
      },
      loaded_view: "StrugglingList",
      show_loader: true,
      loader_text: "Loading Report",
    };
  },

  created() {
    EventBus.$on("event-bus-remount-data", this.getReport);
  },

  mounted() {
    this.setCurrentClass(this.$route.params.id);
  },

  methods: {
    ...mapActions(["getClassReport", "setCurrentClass"]),

    clearOutOptionalPrams() {
      this.topic_id = null;
      this.subject = null;
      this.term = null;
    },

    toggleTeacherModal() {
      this.teacher_modal = !this.teacher_modal;
    },

    getReport() {
      this.show_loader = true;
      let url = `/report/class?class_id=${this.$route.params.id}&data=topic`;

      if (this.topic_id) url += `&topic_id=${this.topic_id}`;
      if (this.subject) url += `&subject=${this.subject}`;
      if (this.term) url += `&term=${this.term}`;

      this.getClassReport(url)
        .then((response) => {
          this.show_loader = false;
          // console.log(response);
          if (response.code === 200) {
            let report = response.data;

            this.current_term = report.current_term;
            this.current_subject = report.current_subject;
            this.subject_list = report.subjects;

            this.report_data.current_subject = report.current_subject;
            this.report_data.current_topic = report.current_topic;
            this.report_data.topic_list = report.topic_list;
            this.report_data.struggling_student =
              report.topic_performance.struggling;
            this.report_data.average_student = report.topic_performance.average;
            this.report_data.excellence_student =
              report.topic_performance.excellence;
            this.report_data.total_student_count =
              report.topic_performance.studentsCount;

            let report_list = [
              ...this.report_data.struggling_student,
              ...this.report_data.average_student,
              ...this.report_data.excellence_student,
            ];

            if (this.report_data.struggling_student.length > 0)
              this.loaded_view = "StrugglingList";
            else if (this.report_data.average_student.length > 0)
              this.loaded_view = "AverageList";
            else if (this.report_data.excellence_student.length > 0)
              this.loaded_view = "TopList";
            else this.loaded_view = "StrugglingList";

            this.total_report_count = report_list.length;
          } else {
            console.log("No report");
          }
        })
        .catch((err) => console.log(err));
    },

    updateParam(value, type) {
      this.show_loader = true;
      this[type] = value;
      this.getReport();
    },
  },
};
</script>

<style lang="scss">
.class-report-section {
  .right-layout {
    @include breakpoint_max(lg) {
      padding-left: 30px;
      padding-right: 0px;
    }

    @include breakpoint_max(md) {
      margin-bottom: 80px;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
}

// PAGE TITLE
.page-title {
  font-size: 21px;
  line-height: 29px;
  margin-bottom: 30px;

  @include breakpoint_max(lg) {
    font-size: 20px;
  }

  @include breakpoint_max(sm) {
    font-size: 16px;
    margin-top: 15px;
    margin-bottom: -10px !important;
  }
}

.report-intro-row {
  margin-top: 30px;
  margin-bottom: 20px;

  .form-control {
    position: relative;
    border-radius: 30px;
    border: 1px solid $border_grey_light;
    box-sizing: border-box;
    font-size: 13px;
    color: $color_grey_dark;
    padding: 8px 20px;

    &:focus {
      border: 1px solid $brand_accent;
    }

    @include breakpoint_max(xs) {
      font-size: 12px;
    }
  }

  .subject {
    width: 170px;

    @include breakpoint_max(xs) {
      width: 160px;
    }
  }

  .term {
    width: 120px;
    margin-left: 15px;

    @include breakpoint_max(xs) {
      width: 110px;
    }
  }

  .export-btn {
    @include flex_row_between_nowrap;
    background: #ffffff;
    border: 1px solid $border_grey_light;
    box-sizing: border-box;
    width: 110px;
    padding: 6px 20px;
    font-size: 12px;
    line-height: 16px;
    transition: all 0.4s ease-in-out;

    span {
      font-size: 16px;
      margin-left: 11px;
      transition: all 0.4s ease-in-out;
    }

    &:hover {
      background: $brand_primary;
      border: 1px solid $brand_primary;
      color: #ffffff !important;

      span {
        color: #ffffff !important;
      }
    }
  }
}
</style>
